import { render, staticRenderFns } from "./ChatListPopup.vue?vue&type=template&id=5b2bcc24&scoped=true"
import script from "./ChatListPopup.vue?vue&type=script&lang=js"
export * from "./ChatListPopup.vue?vue&type=script&lang=js"
import style0 from "./ChatListPopup.vue?vue&type=style&index=0&id=5b2bcc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2bcc24",
  null
  
)

export default component.exports